<div
  class="flex flex-col-reverse md:flex-row md:justify-between md:h-[18.125rem] pt-4 md:pt-0 w-full rounded-xl card-result-{{variant()}} transition-shadow duration-300"
  [class.hover:cursor-pointer]="link()"
  [class.hover:shadow-xl]="link()"
  (click)="handleClick()"
>
  <div class="flex flex-col p-6 md:w-[50%] flex-1 min-h-0">
    <div class="flex items-start justify-between mb-4 md:mb-[1.5rem] shrink-0">
      <h4 >{{ title() }}</h4>
      @if(!isFavoriteLoading() && id() && isAbleToAddToFavorites()) {
      <button
        class="flex hover:cursor-pointer"
        (click)="$event.stopPropagation(); toggleFavorite()"
      >
        <icon
          [name]="isFavorite()? 'thumb-up-filled' : 'thumb-up'"
          [size]="'2.25rem'"
          aria-hidden="true"
          class="flex-shrink-0 p-2"
        ></icon></button
      >}
    </div>
    <div class="flex flex-col justify-between flex-1 min-h-0">
      <p
        class="py-2 text-[0.875rem] md:max-w-[18.75rem] !font-light wysiwyg max-h-[9.375rem] overflow-y-auto min-h-0"
        [innerHTML]="text() | safeHtml"
      ></p>
      <button
        class="cta mt-6 shrink-0"
        (click)="$event.stopPropagation(); handleClick()"
      >
        {{'components.cardResult.discover' | transloco }}<icon
          [name]="'arrow-right'"
          [size]="'0.875rem'"
        ></icon>
      </button>
    </div>
  </div>
  @if(image() && image() !== '') {
  <img
    [src]="image()"
    alt="Card result"
    class="h-[8.25rem] md:h-[18.125rem] md:w-[50%] object-contain md:object-cover rounded-xl md:rounded-l-none"
  />
  }
</div>

@if(isRedirectionExternal() && isModalOpen() ){
<app-modal
  [title]="'components.cardResult.redirectModaleTitle' | transloco"
  [buttonText]="'components.cardResult.redirectModaleCtaText' | transloco"
  [text]="modalTextDisclaimerResolved()"
  (closeModal)="closeModal()"
  (completeModal)="completeModal()"
></app-modal>
}
